<div id="fachgebiete" class="page-wrapper">

	<app-menu [activeMenuIndex]="6">
	</app-menu>

	<!--<div class="subheader-bar-wrapper">
		<div class="subheader-content">
			<a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
				<div class="subheader-content-text">
					Ihr kostenfreies Testset!
				</div>
			</a>
		</div>
	</div>-->

	<div class="title-wrapper">
    <div class="m-t-30 img-header">
      <img src="/assets/img/template/02-kardiologie/herz-header.png" />
    </div>
		<h1>
			Kardiologie
		</h1>
		<div class="title-description">
      <ul class="bullet-kardiologie">
        <li>Jeder zweite Morbus Fabry-Patient stirbt an kardiovaskulären Komplikationen.<sup class="info-section-text-ref">1</sup></li>
        <li>Eine kardiale Beteiligung liegt bei ca. 60% der Fabry-Patienten vor.<sup class="info-section-text-ref">2</sup></li>
        <li>Die Prävalenz kardialer Symptome steigt mit dem Alter der Patienten.<sup class="info-section-text-ref">3</sup></li>
        <li>Typische Auffälligkeiten der Herzstruktur und -funktion lassen sich mit verschiedenen bildgebenden Verfahren darstellen. Besonders häufig: <a href="fachgebiete/kardiologie#section-1" class="color-kardiologie"><strong>linksventrikuläre Hypertrophie (LVH) ≥ 12 mm</strong></a> ohne/mit Hypertonie.</li>
      </ul>
		</div>
	</div>

  <div class="info-section fullwidth info-ribbon with-video-float color-white bgcolor-kardiologie">
    <div class="ribbon-left"><img src="/assets/img/template/02-kardiologie/dreieck-1.png"></div>
    <div class="info-section-title">
			Wann sollte in der Kardiologie an Morbus Fabry gedacht werden?
		</div>
    <p class="text-center">
      Das erfahren Sie in dem Expertenvideo<br>
      mit Prof. Dr. Fabian Knebel, Berlin.
		</p>
    <div class="video-float">
      <iframe src="https://www.youtube.com/embed/36EinEUEoiY" class="kardiologie" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
	</div>

  <!--  <app-login zone="education">-->
    <app-login zone="2000000017231"> <!-- Development -->
  <!--  <app-login zone="2000000017234"> <!-- Takeda Server -->
  <!--    <app-login zone="2000000017234"> <!-- Production -->
  </app-login>

  <app-footer>
  </app-footer>

</div>

